import Reactotron from './../ReactotronConfig';
import { applyMiddleware, createStore, compose } from 'redux';
import reducers from './reducer';
import { default as promise } from 'redux-promise';

const store = createStore(
  reducers,
  undefined,
  compose(
    applyMiddleware(promise),
    Reactotron.createEnhancer()
  )
);

export default store;
